export interface MaterialOnsiteType {
    id: number;
    estimation_id: number | null;
    onsite_quantity: number | null;
    date: string | null;
}

// to single object maping
export const mapMaterialOnsiteType = (data: any): MaterialOnsiteType => {
    if (!data) {
        throw new Error('Invalid Data')
    }

    const materialOnsiteType: MaterialOnsiteType = {
        id: data.id,
        estimation_id: data.estimation_id || null,
        onsite_quantity: data.onsite_quantity || null,
        date: data.date || null,
    }

    return materialOnsiteType;
}

// maping list objects
export const mapMaterialOnsiteTypes = (data: any[]): MaterialOnsiteType[] => {
    if (!Array.isArray(data)) {
        throw new Error('Invalid Data');
    }
    
    return data.map(mapMaterialOnsiteType);
}